(function () {
    // Locale bilgisi (cookie'den veya tarayıcıdan)
    function getLocale() {
      return document.cookie
        .split('; ')
        .find(row => row.startsWith('siteLocale='))
        ?.split('=')[1] || navigator.language;
    }
  
    // Extract airport code from full airport text
    function extractAirportCode(airportText) {
      if (!airportText) return '';
      const match = airportText.match(/\(([A-Z]{3})\)/);
      return match ? match[1] : airportText;
    }
  
    function formatDate(dateStr) {
      if (!dateStr) return '';
      const parts = dateStr.split('.');
      if (parts.length === 3) {
        const formatted = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);
        if (!isNaN(formatted.getTime())) {
          const locale = getLocale();
          const isArabic = locale.startsWith('ar');
          
          // For Arabic, use Arabic locale
          if (isArabic) {
            return formatted.toLocaleDateString('ar', {
              day: '2-digit',
              month: 'short'
            });
          }
          
          // For English and others, use custom format
          const day = formatted.getDate().toString().padStart(2, '0');
          const month = formatted.toLocaleDateString('en', { month: 'short' });
          return `${day} ${month}`;
        }
      }
      return '';
    }
  
    // Gidiş tipi çevirisi
    function getTripTypeLabel(tripType) {
      const locale = getLocale();
      const isArabic = locale.startsWith('ar');
      if (tripType === 'roundtrip') {
        return isArabic ? 'ذهاب وعودة' : 'ROUND TRIP';
      }
      return isArabic ? 'ذهاب فقط' : 'ONE WAY';
    }
  
    // Extract airport code and city from full airport text
    function extractAirportCodeAndCity(airportText) {
      // Example: "Baghdad (BGW)Baghdad International Arpt, IQ"
      const codeMatch = airportText.match(/\(([A-Z]{3})\)/);
      const code = codeMatch ? codeMatch[1] : '';
      // For city code, fallback to code (unless you have a better way)
      return { code };
    }
  
    // Helper to validate airport ID (e.g., 6IST2)
    function isValidAirportId(id) {
      return /^6[A-Z]{3}\d$/.test(id);
    }
  
    // Handle recent search click
    function handleRecentSearchClick(item) {
      // Set visible fields
      document.getElementById('fromAirport').value = item.from;
      document.getElementById('toAirport').value = item.to;

      // Set hidden fields from item if available and valid, else show alert and abort
      if (item.fromId && item.toId && isValidAirportId(item.fromId) && isValidAirportId(item.toId)) {
        document.getElementById('fromAirportId').value = item.fromId;
        document.getElementById('toAirportId').value = item.toId;
        document.getElementById('fromAirportCity').value = item.fromCity || '';
        document.getElementById('toAirportCity').value = item.toCity || '';
      } else {
        alert('This recent search does not have valid airport information. Please search again.');
        return;
      }

      // Set trip type and handle return date
      if (item.tripType === 'roundtrip') {
        document.getElementById('btnradio2').checked = true;
        document.getElementById('dateReturn').style.display = 'block';
        document.getElementById('roundTripDates').style.display = 'block';
        document.getElementById('dateDeparture').classList.add('col-6');
        document.getElementById('dateDeparture').classList.remove('col-12');
        // Set return date
        document.getElementById('returnDate').value = item.returnDate || '';
      } else {
        document.getElementById('btnradio1').checked = true;
        document.getElementById('dateReturn').style.display = 'none';
        document.getElementById('roundTripDates').style.display = 'none';
        document.getElementById('dateDeparture').classList.add('col-12');
        document.getElementById('dateDeparture').classList.remove('col-6');
        // Clear return date
        document.getElementById('returnDate').value = '';
      }

      // Set departure date
      document.getElementById('departureDate').value = item.date;

      // Trigger any necessary events
      const event = new Event('change');
      document.getElementById('fromAirport').dispatchEvent(event);
      document.getElementById('toAirport').dispatchEvent(event);
      document.getElementById('departureDate').dispatchEvent(event);
      document.getElementById('returnDate').dispatchEvent(event);
    }
  
    // Recent search kartlarını render et
    function renderRecentSearches() {
      const container = document.getElementById('recent-searches');
      const wrapper = container?.closest('.recent-searches');
      if (!container) return;
  
      const items = JSON.parse(localStorage.getItem('recentFlightSearches') || '[]');
  
      // Show/hide the wrapper based on items
      if (wrapper) {
        if (items.length === 0) {
          wrapper.style.display = 'none';
        } else {
          wrapper.style.display = '';
        }
      }
  
      container.innerHTML = '';
  
      items.forEach((item) => {
        if (!item.from || !item.to) return;
  
        const card = document.createElement('div');
        card.className = 'recent-search-card d-inline-block text-center bg-gray-50 rounded-3 small p-2';
        card.style.minWidth = '120px';
        card.style.cursor = 'pointer';
        card.onclick = () => handleRecentSearchClick(item);
  
        const fromText = extractAirportCode(item.from);
        const toText = extractAirportCode(item.to);
        const depDate = formatDate(item.date);
        const returnDate = formatDate(item.returnDate);
        const tripText = getTripTypeLabel(item.tripType);
  
        let dateDisplay = depDate || '-';
        if (item.tripType === 'roundtrip' && returnDate) {
          dateDisplay = `${depDate} - ${returnDate}`;
        }
  
        card.innerHTML = `
          <div class="d-flex align-items-center justify-content-center gap-2 mb-2">
            <span class="from badge rounded-pill border border-primary text-primary bg-white">${fromText}</span>
            <span class="text-primary"><svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-right mx-0.5 text-rafeef-green"><path d="M5 12h14"></path><path d="m12 5 7 7-7 7"></path></svg></span>
            <span class="to badge rounded-pill border border-primary text-primary bg-white">${toText}</span>
          </div>
          <div class="date fw-semibold text-primary mb-1">${dateDisplay}</div>
          <div class="trip-type text-muted small">${tripText}</div>
        `;
  
        container.appendChild(card);
      });
    }
  
    // Save a new search
    window.saveRecentFlightSearch = function (search) {
      if (!search || !search.from || !search.to) return;
      // Only save if IDs are valid
      if (!isValidAirportId(search.fromId) || !isValidAirportId(search.toId)) {
        return;
      }
      let items = JSON.parse(localStorage.getItem('recentFlightSearches') || '[]');
      items = items.filter(i =>
        !(i.from === search.from && i.to === search.to && i.date === search.date && i.returnDate === search.returnDate && i.tripType === search.tripType)
      );
      items.unshift(search);
      if (items.length > 5) items = items.slice(0, 5);
      localStorage.setItem('recentFlightSearches', JSON.stringify(items));
      renderRecentSearches();
    };
  
    // Clear all
    function clearAllRecentSearches() {
      localStorage.removeItem('recentFlightSearches');
      renderRecentSearches();
    }
  
    // Attach clear button
    function attachClearHandler() {
      const btn = document.getElementById('clear-all');
      if (btn) {
        btn.onclick = function (e) {
          e.preventDefault();
          clearAllRecentSearches();
        };
      }
    }
  
    // Init
    function initialize() {
      renderRecentSearches();
      attachClearHandler();
    }
  
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  })();